import {createReducer} from '../utility'


export const userBillers = createReducer({},{
    "USER_BILLS_RECEIVED"(state, {data}){
        if(data){
            return {
                ...state,
                data: data
            }
        }else{
            return{
                ...state
            }
        }
    } 
})


export const billDetails = createReducer({},{
    "BILLER_DETAILS_RECEIVED"(state, {data}){
        if(data){
            return {
                ...state,
                data: data
            }
        }else{
            return{
                ...state
            }
        }
    } 
})